import { Button } from "@/components/ui/button";
import React from "react";
import { useTranslation } from "react-i18next";

export function StripeAction({
  show,
  loading,
  disabled,
  onClick,
}: {
  show: boolean;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <Button
      variant="new_default"
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? t("billing.openingStripe") : t("billing.continueOnboarding")}
    </Button>
  );
}
